import { Modal, IconButton } from "rsuite";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import CloseIcon from "@rsuite/icons/Close";
import { CloudAlert, X } from "lucide-react";

const ProductErrorModal = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="xs"
      backdrop={true}
      keyboard={false}
    >
      {/* Custom Header with Close Button */}
      <div className="d-flex justify-content-end p-3 border-bottom">
        <IconButton
          icon={<CloseIcon />}
          appearance="subtle"
          onClick={onClose}
          size="sm"
          className="rounded-circle"
          style={{ 
            backgroundColor: '#FFDB80',
            color: '#8077EC'
          }}
        />
      </div>

      <Modal.Body>
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
          className="text-center p-4"
        >
          {/* Error Icon */}
          <div className="mb-4">
            <div 
              className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
              style={{ 
                width: '80px', 
                height: '80px', 
                backgroundColor: '#dc3545',
                fontSize: '2.5rem'
              }}
            >
                <CloudAlert size={40} color="#ffffff"/>
            </div>
          </div>

          <h4 className="mb-3 fw-bold text-danger">
            {t("submission_error_title")}
          </h4>

          <p className="mb-4 text-muted">
            {t("submission_error_message")}
          </p>
        </motion.div>
      </Modal.Body>
    </Modal>
  );
};

export default ProductErrorModal;